import { LocalDate } from "@js-joda/core";

const MINIMUM_CUT_OFF_DAY = 10;
const MAXIMUM_CUT_OFF_DAY = 20;

export function getSalaryCutOffDay(value: string | undefined): number {
  const day = Number(value);
  if (!Number.isInteger(day)) return 0;
  if (day === 0) return 0;
  return day >= MINIMUM_CUT_OFF_DAY && day <= MAXIMUM_CUT_OFF_DAY ? day : 0;
}

interface SalaryCutOffDateParams {
  readonly cutOffDay: number;
  readonly period: LocalDate;
}

export function getSalaryCutOffDate({
  cutOffDay,
  period,
}: SalaryCutOffDateParams): LocalDate {
  const day = cutOffDay === 0 ? period.lengthOfMonth() : cutOffDay;
  return LocalDate.of(period.year(), period.monthValue(), day);
}

export function getSalaryNoticeWorkPeriod(
  salaryNoticePeriod: LocalDate,
): LocalDate {
  return salaryNoticePeriod.minusMonths(1);
}

interface BeforeSalaryCutOffParams {
  readonly cutOffDay: number;
  readonly period: LocalDate;
  readonly today: LocalDate;
}

export function isBeforeSalaryCutOff({
  cutOffDay,
  period,
  today,
}: BeforeSalaryCutOffParams): boolean {
  return today.isBefore(getSalaryCutOffDate({ cutOffDay, period }));
}

interface CurrentOrPastMonthParams {
  readonly month: LocalDate;
  readonly today: LocalDate;
}

export function isCurrentOrPastMonth({
  month,
  today,
}: CurrentOrPastMonthParams): boolean {
  return (
    month.year() < today.year() ||
    (month.year() === today.year() && month.monthValue() <= today.monthValue())
  );
}
